/**
 * Shared react-select styles and classNames that match the project's color scheme.
 * Usage:
 *   import { reactSelectStyles, reactSelectClassNames } from '../components/reactSelectStyles';
 *   <Select styles={reactSelectStyles} classNames={reactSelectClassNames} ... />
 */

export const reactSelectStyles = {
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? "#004494" : "#d1d5db",
    boxShadow: state.isFocused ? "0 0 0 1px #004494" : "none",
    borderRadius: "0.375rem",
    minHeight: "2.5rem",
    backgroundColor: "#ffffff",
    "&:hover": {
      borderColor: state.isFocused ? "#004494" : "#9ca3af",
    },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? "#004494" : state.isFocused ? "#e6f0fc" : "#ffffff",
    color: state.isSelected ? "#ffffff" : "#374151",
    cursor: "pointer",
    "&:active": {
      backgroundColor: "#b4d1f5",
    },
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#e6f0fc",
    borderRadius: "0.25rem",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "#004494",
    fontWeight: "500",
    fontSize: "0.8125rem",
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "#004494",
    borderRadius: "0 0.25rem 0.25rem 0",
    "&:hover": {
      backgroundColor: "#004494",
      color: "#ffffff",
    },
  }),
  placeholder: (base) => ({
    ...base,
    color: "#6b7280",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#374151",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#6b7280",
    "&:hover": { color: "#374151" },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: "#6b7280",
    "&:hover": { color: "#dc2626" },
  }),
  menu: (base) => ({
    ...base,
    borderRadius: "0.375rem",
    boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
    border: "1px solid #e5e7eb",
  }),
  menuList: (base) => ({
    ...base,
    padding: "0.25rem",
  }),
};

export const reactSelectClassNames = {
  control: () => "text-sm",
  input: () => "[&_input:focus]:ring-0",
};
